import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactForm from '../../components/ContactForm';
import CTAButton from '../../components/CTAButton';
import SEO from '../../components/SEO';

const RoofTileCleaning = () => {
  return (
    <>
      <SEO 
        title="Roof & Tile Cleaning Services Kampala | Professional Roof Cleaning Uganda"
        description="Expert roof & tile cleaning in Kampala. Remove moss, algae & stains. Extend roof lifespan & improve curb appeal. Safe cleaning methods. Call 0752 058 190"
        keywords="roof cleaning Kampala, tile cleaning Uganda, moss removal roof, roof maintenance Kampala, gutter cleaning Uganda, roof washing services"
        url="https://blossomcleaningservices.com/services/roof-tile-cleaning"
      />
      <Header />

      <Box sx={{ position: 'relative', py: 12, backgroundImage: 'url(https://images.unsplash.com/photo-1632778297991-82ee0a353f03?w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(34, 51, 95, 0.75)' } }}>
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography variant="h1" sx={{ mb: 3, color: 'white', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
              Roof & Tile Cleaning
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: 800, color: 'rgba(255,255,255,0.95)', mb: 4 }}>
              Professional roof cleaning to extend lifespan and improve appearance
            </Typography>
            <CTAButton to="/contact">Get Quote</CTAButton>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
            Specialised Roof Cleaning Services
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Over time, roofs accumulate moss, algae, dirt, and debris that can damage tiles and reduce your property's curb appeal. Our specialised roof cleaning service safely removes all buildup without damaging your roof.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Using low-pressure techniques and eco-friendly cleaning solutions, we restore your roof's appearance and extend its lifespan. Regular roof cleaning prevents costly repairs and maintains your property value.
          </Typography>
        </Container>
      </Box>

      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="md">
          <ContactForm title="Request Roof Cleaning" showServiceSelect={false} />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default RoofTileCleaning;
